import { type AgentStatistic } from '@lucidtech/las-sdk-browser';

import { create } from '@/hooks/api';

export type AgentStatisticId = { agentId: string; before?: Date; after?: Date };

export const { getOptions: getAgentStatisticOptions, useGet: useGetAgentStatistics } = create<
  AgentStatistic,
  AgentStatisticId,
  { agentId: string }
>({
  cacheKey: 'agentStatistics',
  equal: (agentStatistic, id) =>
    Boolean(
      agentStatistic &&
        id?.agentId &&
        agentStatistic.agentId === id.agentId &&
        agentStatistic.before === id.before &&
        agentStatistic.after === id.after
    ),
  createId: (agentStatistic) =>
    agentStatistic
      ? { agentId: agentStatistic.agentId, before: agentStatistic.before, after: agentStatistic.after }
      : null,
  get: (client, id) => {
    return new Promise((resolve, reject) => {
      client
        .getAgentStatistics(id.agentId, { ...id })
        .then((response: AgentStatistic) => {
          if (id.before) response.before = id.before;
          if (id.after) response.after = id.after;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
});

export const toAgentStatisticId = (
  agentId?: string | null,
  before?: Date | null,
  after?: Date | null
): AgentStatisticId | null => {
  if (!agentId) return null;
  const id: AgentStatisticId = { agentId };
  if (before) id.before = before;
  if (after) id.after = after;
  return id;
};
